import { ILogEntry } from 'motw_core/Entity/ILogEntry';
import { ChangeData } from './ChangeData';
import { ResetEditableState } from './ResetEditableState';

export function HandleLogEntryEdit(
	event: React.ChangeEvent<HTMLElement>,
	data: ILogEntry[],
	row: ILogEntry,
	column: number
) {
	ChangeData(data, {
		row: row.id,
		column,
		data: event.target.textContent as string
	});

	ResetEditableState();
}


